import { defineThemeConfig } from '@core'
import { Skins } from '@core/enums'
import { breakpointsVuetify } from '@vueuse/core'
import { VIcon } from 'vuetify/components/VIcon'

// ❗ Logo SVG must be imported with ?raw suffix
// import logo from '@images/logo.svg?raw'
import { AppContentLayoutNav, ContentWidth, FooterType, NavbarType } from '@layouts/enums'
import logo from '/images/cdms_logo.png'

export const { themeConfig, layoutConfig } = defineThemeConfig({
  app: {
    title: 'CDMS',
    logo: logo,
    contentWidth: ContentWidth.Fluid,     // ContentWidth.Boxed
    contentLayoutNav: AppContentLayoutNav.Vertical,

    // contentLayoutNav: AppContentLayoutNav.Horizontal,
    overlayNavFromBreakpoint: breakpointsVuetify.md + 16,
    i18n: {
      enable: true,
      defaultLocale: 'ko',
      langConfig: [
        {
          label: 'English',
          i18nLang: 'en',
          isRTL: false,
        },
        {
          label: 'Korean',
          i18nLang: 'ko',
          isRTL: false,
        },

        // {
        //   label: 'French',
        //   i18nLang: 'fr',
        //   isRTL: false,
        // },
        // {
        //   label: 'Arabic',
        //   i18nLang: 'ar',
        //   isRTL: true,
        // },
      ],
    },
    theme: 'light',  // system
    skin: Skins.Default,
    iconRenderer: VIcon,
  },
  navbar: {
    type: NavbarType.Sticky,
    navbarBlur: true,
  },
  footer: { type: FooterType.Static },
  verticalNav: {
    isVerticalNavCollapsed: true,
    defaultNavItemIconProps: { icon: 'tabler-circle', size: 10 },
    isVerticalNavSemiDark: false,
  },
  horizontalNav: {
    type: 'sticky',
    transition: 'slide-y-reverse-transition',
  },

  /*
    // ℹ️  In below Icons section, you can specify icon for each component. Also you can use other props of v-icon component like `color` and `size` for each icon.
    // Such as: chevronDown: { icon: 'tabler-chevron-down', color:'primary', size: '24' },
    */
  icons: {
    chevronDown: { icon: 'tabler-chevron-down' },
    chevronRight: { icon: 'tabler-chevron-right', size: 18 },
    close: { icon: 'tabler-x' },

    // verticalNavPinned: { icon: 'tabler-pinned-filled' },
    // verticalNavUnPinned: { icon: 'tabler-pin' },
    verticalNavPinned: { src: '/images/pin_on.png',  alt: 'Pin',   size: 20 },
    verticalNavUnPinned: { src: '/images/pin_off.png', alt: 'Unpin', size: 20 },
    sectionTitlePlaceholder: { icon: 'tabler-separator' },
  },
})
